import React from "react";
import { registerOverlay } from "../overlays";
import { useLang } from "../i18n";
import { emphasise } from "../emphasis";

function Statement({ id, label, children }) {
  return (
    <div
      ref={(el) => registerOverlay(id, el)}
      className="fixed inset-0 z-10 flex flex-col items-center justify-center px-6 text-center"
      style={{ willChange: "opacity, transform", opacity: 0 }}
    >
      <p className="ff-mono text-xs uppercase tracking-[0.2em] mb-6" style={{ color: "var(--bb-ink-muted)" }}>
        {label}
      </p>
      <h2 className="ff-head text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-[-0.02em] max-w-[20ch]" style={{ color: "var(--bb-ink)" }}>
        {children}
      </h2>
    </div>
  );
}

export default function NoiseOverlay() {
  const { t } = useLang();
  const n = t.noise;
  return (
    <>
      {/* The emphasised word is the turn in each sentence: what you were left
          with ("behind"), and what you didn't get ("means"). */}
      <Statement id="noise-1" label={n.label}>{emphasise(n.s1, n.s1Em)}</Statement>
      <Statement id="noise-2" label={n.label}>{emphasise(n.s2, n.s2Em)}</Statement>
      <Statement id="noise-3" label={n.labelSignal}>
        {n.s3a}
        <span style={{ color: "var(--bb-red)" }}>{n.s3b}</span>
        {n.s3c}
      </Statement>
    </>
  );
}
